import { axiosInstance } from '@cxnpl/api/axios';
import { baseUrl } from '@cxnpl/api/baseUrl';

/**
 * Refresh user token via configured axios instance.
 * Axios instance has interceptors which will refresh the token if it is expired.
 * If you wish to call this method within a component, consider using the hook
 * `useRefreshToken` instead, defined in `app/api/internal/useRefreshToken.ts`.
 *
 * @param entityId - The entity ID of the business to refresh the token for.
 * @param auth0Enabled - Whether Auth0 is enabled.
 */
export async function refreshToken(
  { entityId, auth0Enabled }: { entityId?: string; auth0Enabled: boolean } = { auth0Enabled: false }
): Promise<void> {
  // Toggle refresh endpoint based on whether Auth0 is enabled
  const refreshUrl = auth0Enabled ? '/v2/session/refresh' : '/login/refresh';
  // Using axiosInstance means it will hit interceptors
  await axiosInstance({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-PROTECTION': '1',
    },
    withCredentials: true,
    method: 'POST',
    url: refreshUrl,
    data: {
      entityId,
      appClient: 'WEB',
    },
  });
}
